module.exports = __webpack_public_path__ + "static/downloable/formato-solicitud-de-renovacion-de-certificado-de-supervivencia.544b95e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable/formatos/formato-solicitud-de-renovacion-de-certificado-de-supervivencia.pdf
// module id = QNK4
// module chunks = 1